module.exports = __webpack_public_path__ + "img/start.caab9f65.png";